const enum SDCButtonIconPosition {
  Left = 'left',
  Right = 'right',
}
export default SDCButtonIconPosition;
